export const DO_LOGIN = 'DO_LOGIN'

export const DO_LOGOUT = 'DO_LOGOUT'

export const VISITED = 'VISITED'